// @ts-nocheck
export const openChat = () => {
    if (window.customerFirstAPI !== undefined) {
        window.customerFirstAPI.openWidget();
    }
    else if (window.$kundo_chat !== undefined) {
        window.$kundo_chat.start_chat();
    }
    else {
        alert("Tyvärr går det inte komma åt chatten för närvarande.");
    }
};
